import _extends from '@babel/runtime/helpers/extends';
import _jsx from '@babel/runtime/helpers/jsx';
import React from 'react';
import classnames from 'classnames';
import { hyphenatedbem } from '@vpp-frontend-components/common';
import * as Grid from '@vpp-frontend-components/grid';
const prefix = 'ui-pdp';
const namespace = `${prefix}-component-list`;

/**
 * Container component
 * @typedef {import('../index').Container}
 */
const Container = _ref => {
  let {
    children,
    hasContainerTop
  } = _ref;
  if (hasContainerTop) {
    return /*#__PURE__*/_jsx(Grid.Container, {
      className: classnames({
        'ui-pdp-container--top': hasContainerTop
      })
    }, void 0, children);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

/**
 * ComponentList component
 * @typedef {import('../index').ComponentList}
 */
const ComponentList = _ref2 => {
  let {
    availableComponents,
    initialState: {
      components
    },
    modifier = null,
    hasContainerTop = false
  } = _ref2;
  if (!components) {
    return null;
  }
  return /*#__PURE__*/_jsx(Container, {
    hasContainerTop: hasContainerTop
  }, void 0, components.map((component, i) => {
    const ReactComponent = availableComponents[`${component.type}/${component.id}`] || availableComponents[component.type];
    if (!ReactComponent || component.state === 'HIDDEN') {
      return null;
    }
    ReactComponent.displayName = `CL${component.id}`;
    return /*#__PURE__*/ /* eslint-disable-next-line react/no-array-index-key */_jsx(React.Fragment, {}, `${component.id || component.type}-${i}`, /*#__PURE__*/_jsx(Grid.Row, {
      modifier: hyphenatedbem(component.id),
      className: classnames({
        [`${namespace}__item--desktop-${modifier}`]: modifier
      })
    }, void 0, /*#__PURE__*/React.createElement(ReactComponent, _extends({
      component_id: component.id
    }, component))));
  }));
};
export { ComponentList };
